<div
  id="sticky-progress-bar"
  class="right-0 bottom-0 left-0 z-30 fixed flex justify-between items-center gap-3 bg-black px-4 md:px-8 py-2 w-full text-white">
  <!-- Breadcrumb (hidden on mobile to leave room for the CTA, per DEC-003) -->
  <div class="hidden lg:flex items-center gap-2 min-w-0 text-xs xl:text-sm">
    @for (step of steps(); track step; let i = $index; let last = $last) {
      <span
        class="whitespace-nowrap"
        [class.font-bold]="i + 1 === currentStep()"
        [class.opacity-50]="i + 1 !== currentStep()">
        {{ i + 1 }}. {{ step }}
      </span>
      @if (!last) {
        <span class="opacity-30 w-6 border-current border-t"></span>
      }
    }
  </div>

  <!-- Page-specific totals slot -->
  <div class="flex flex-1 justify-center lg:justify-end items-center min-w-0">
    <ng-content></ng-content>
  </div>

  <!-- CTA -->
  <button
    type="button"
    [attr.data-cy]="ctaDataCy()"
    class="flex justify-center items-center gap-1.5 disabled:opacity-30 min-w-max disabled:hover:transform-none hover:scale-95 transition-transform"
    [ngClass]="ctaClasses"
    [disabled]="ctaDisabled()"
    [title]="ctaTooltip()"
    (click)="onCtaClick()">
    {{ ctaLabel() }}
    <!-- Lock icon (Figma `1683:17`) — payment-submit state only, see ctaShowLockIcon(). -->
    @if (ctaShowLockIcon()) {
      <img
        src="/assets/img/lock-icon-white.svg"
        alt=""
        class="w-[12.7px] h-[16.7px]" />
    }
  </button>
</div>
